import React from 'react';

const MessageLoader = () => {
  return <div className={'message-loader'} />;
};

export default MessageLoader;
